import IMask from 'imask';

export default class {
   phoneInputs = document.querySelectorAll('.phone-mask');

   constructor() {
      this.phoneInputs.forEach(phone => {
         var phoneMask = IMask(
            phone, {
            mask: '+{7} (000) 000-00-00',
         });
      })
   }
}